import { Chart } from '@frontend/chart/types';

import { formatChartSeriesName } from './format-chart-series-name';
import { PeriodComparisonMetric, toPeriodComparisonMetric } from './to-period-comparison-metric';

export interface PeriodComparisonListItem extends PeriodComparisonMetric {
    key: string;
    name: string;
}

export const toPeriodComparisonListItems = (chart: Chart, unknownLabel: string): PeriodComparisonListItem[] => {
    const items: PeriodComparisonListItem[] = [];

    for (const series of chart.series) {
        const name = formatChartSeriesName(series.name, unknownLabel);
        if (!name) {
            continue;
        }

        const metric = toPeriodComparisonMetric({ series: [series] });
        if (!metric) {
            continue;
        }

        items.push({ key: series.name ?? name, name, ...metric });
    }

    return items;
};
